import BreadCrumbs from '@/components/atom/BreadCrumbs';
import PaginationComponent from '@/components/common/PaginationComponent';
import LinkTag from '@/components/common/link-tag';
import TemplateLayout from '@/components/layouts/TemplateLayout';
import { zIndex } from '@/constants/zIndex';
import DNSearchBar from '@/design-components/organisms/dnsearch-bar';
import MedicineDictionary from '@/entities/medicine-dictionary/ui/MedicineDictionary';
import { createMedicineDictionaryDetailUrl } from '@/entities/medicine-dictionary/util';
import MedicineDictionaryEmptyState from '@/features/medicine-dictionary/ui/MedicineDictionaryEmptyState';
import { MedicineDictionarySearchViewModel } from '@/hooks/medicine-dictionary/useMedicineDictionarySearchViewModel';
import { Client, ClientType } from '@/types/app';
import { ROUTES } from '@/types/common';
import React from 'react';

interface Props {
  viewModel: MedicineDictionarySearchViewModel;
  client: Client;
}

const MedicineDictionarySearchTemplate = (props: Props) => {
  return (
    <TemplateLayout.Wrapper>
      {props.client.clientType === ClientType.WEB && (
        <BreadCrumbs.Wrapper>
          <BreadCrumbs
            visible
            name='검색결과'
            type='medicine_dictionary'
            path={`${ROUTES.MEDICINE_DICTIONARY.SEARCH.path}`}
          />
        </BreadCrumbs.Wrapper>
      )}

      <h1 className='typography-ui-22sb px-[24px] py-[16px] text-gray-900'>의약품 사전</h1>

      <div
        className='px-[24px] py-[16px]'
        style={{
          zIndex: zIndex.AppHeader,
          top: props.client.clientType === ClientType.MOBILE_WEB ? '60px' : '0px',
        }}
      >
        <DNSearchBar
          value={props.viewModel.keyword}
          placeholder={'약 이름 또는 성분 등'}
          shouldShowResetButton={!!props.viewModel.keyword}
          searchInputRef={props.viewModel.searchInputRef}
          onSubmit={props.viewModel.handleSubmit}
          onReset={props.viewModel.handleResetSearchKeyword}
          onChange={props.viewModel.handleChangeSearchKeyword}
        />
      </div>

      <div className='py-[16px]'>
        <div className='mb-[20px] flex items-center gap-[4px] px-[24px]'>
          <h2 className='typography-ui-17m text-gray-700'>검색결과</h2>
          <span className='typography-ui-17m text-primary-600'>{props.viewModel.totalCount}</span>
        </div>
        {props.viewModel.keywordSearchMedicineDictionary?.elements?.length === 0 ? (
          <MedicineDictionaryEmptyState />
        ) : (
          <>
            <div className='grid grid-cols-1 gap-[20px]'>
              {props.viewModel.keywordSearchMedicineDictionary?.elements?.map((medicine, index, array) => (
                <React.Fragment key={medicine.getPublicId()}>
                  <div className='px-[24px]' key={medicine.getPublicId()}>
                    <LinkTag
                      href={`${createMedicineDictionaryDetailUrl(medicine)}`}
                      onClickNavigateToScreen={props.viewModel.onClickMedicineDictionary(medicine)}
                    >
                      <MedicineDictionary
                        key={medicine.getPublicId()}
                        title={medicine.getBasicInfoName()}
                        description={medicine.getPharmaceuticalEffectLiteracy()}
                        summary={medicine.getWholeSummary()}
                        image={medicine.getRepresentativeImage()}
                      />
                    </LinkTag>
                  </div>
                  {index !== array.length - 1 && <div className='h-[1px] w-full bg-gray-40' />}
                </React.Fragment>
              ))}
            </div>
            <PaginationComponent
              baseUrl={ROUTES.MEDICINE_DICTIONARY.SEARCH.path}
              queries={props.viewModel.queries}
              currentPage={props.viewModel.currentPage}
              perPage={5}
              totalPage={props.viewModel.totalPage}
            />
          </>
        )}
      </div>
    </TemplateLayout.Wrapper>
  );
};

export default MedicineDictionarySearchTemplate;
